import { render, staticRenderFns } from "./CardInfoNumber.vue?vue&type=template&id=689faeb8"
import script from "./CardInfoNumber.vue?vue&type=script&lang=js"
export * from "./CardInfoNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Counter: require('/srv/app/components/counter/Counter.vue').default})
